<template>
  <div
    class="app"
  >
    <!--
      Sem sessão o menu perde as permissões e sobra uma barra vazia. Telas que
      permanecem exibidas ao expirar (o Painel de Status de Comunicação) ficariam
      com um menu sem itens ao lado do aviso de sessão expirada, o que lê como
      tela quebrada. Ver docs/adr/0006-painel-sob-o-shell-da-aplicacao-com-menu.md
    -->
    <main-menu v-if="isAuthenticated" />
    <transition name="default-opacity-transition" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MainMenu from '@/domain/components/layout/Menu';

export default {
  components: {
    MainMenu,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'authenticated',
    }),
  },
};
</script>
